import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    // Web3Forms Access Key
    formData.append('access_key', 'ec779649-25ff-4319-95ea-e7c0a1219140');
    formData.append('subject', `Neue Anfrage über Website von ${formData.get('name')}`);
    formData.append('from_name', 'Website Kontaktformular');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        setIsSubmitted(true);
        form.reset();
        setTimeout(() => setIsSubmitted(false), 5000);
      } else {
        alert('Es gab ein Problem beim Senden. Bitte versuchen Sie es später erneut oder schreiben Sie direkt an info@henkelenergie.de');
      }
    } catch (error) {
      alert('Es gab ein Problem beim Senden. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="kontakt" className="py-24 md:py-32 bg-white" data-id="element-45">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-46">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-48">
            <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6" data-id="element-49">
              Unverbindlich anfragen
            </h2>
            <p className="text-lg text-accent/70 font-light mb-12 max-w-md" data-id="element-50">
              Haben Sie Fragen zu Ihrem Gebäude oder planen Sie eine Sanierung?
              Lassen Sie uns in einem kostenlosen Erstgespräch herausfinden, wie
              ich Sie unterstützen kann.
            </p>

            <div className="space-y-8" data-id="element-51">
              <div className="flex items-start" data-id="element-52">
                <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center text-primary shrink-0 mr-6" data-id="element-53">
                  <MailIcon size={20} data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="text-sm font-medium text-accent/50 uppercase tracking-wider mb-1" data-id="element-56">
                    E-Mail
                  </h4>
                  <a href="mailto:info@henkelenergie.de" className="text-xl text-accent hover:text-primary transition-colors" data-id="element-57">
                    info@henkelenergie.de
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-58">
                <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center text-primary shrink-0 mr-6" data-id="element-59">
                  <PhoneIcon size={20} data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="text-sm font-medium text-accent/50 uppercase tracking-wider mb-1" data-id="element-62">
                    Telefon
                  </h4>
                  <a href="tel:+491735227433" className="text-xl text-accent hover:text-primary transition-colors" data-id="element-63">
                    +49 173 5227433
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-64">
                <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center text-primary shrink-0 mr-6" data-id="element-65">
                  <MapPinIcon size={20} data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <h4 className="text-sm font-medium text-accent/50 uppercase tracking-wider mb-1" data-id="element-68">
                    Standort
                  </h4>
                  <div className="text-xl text-accent" data-id="element-69">
                    <p data-id="element-70">Josephine Henkel</p>
                    <p data-id="element-71">Bastianstraße 10</p>
                    <p data-id="element-72">13357 Berlin</p>
                    <p data-id="element-73">Deutschland</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 pt-8 border-t border-accent/10" data-id="element-74">
              <p className="text-accent/50 font-medium tracking-widest uppercase text-sm" data-id="element-75">
                henkelenergie.de
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-secondary p-8 md:p-12 rounded-2xl" data-id="element-76">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-77">
                <div className="w-16 h-16 bg-primary/20 text-primary rounded-full flex items-center justify-center mb-6" data-id="element-78">
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-79">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-80" />
                  </svg>
                </div>
                <h3 className="text-2xl font-serif text-accent mb-4" data-id="element-81">
                  Vielen Dank für Ihre Anfrage!
                </h3>
                <p className="text-accent/70 font-light" data-id="element-82">
                  Ich werde mich schnellstmöglich bei Ihnen melden, um einen
                  Termin für unser Erstgespräch zu vereinbaren.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-83">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-84">
                  <div className="space-y-2" data-id="element-85">
                    <label htmlFor="name" className="text-sm font-medium text-accent/80" data-id="element-86">
                      Name
                    </label>
                    <input type="text" id="name" name="name" required className="w-full px-4 py-3 bg-white border border-accent/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all" data-id="element-87" />
                  </div>
                  <div className="space-y-2" data-id="element-88">
                    <label htmlFor="email" className="text-sm font-medium text-accent/80" data-id="element-89">
                      E-Mail
                    </label>
                    <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-white border border-accent/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all" data-id="element-90" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-91">
                  <div className="space-y-2" data-id="element-92">
                    <label htmlFor="phone" className="text-sm font-medium text-accent/80" data-id="element-93">
                      Telefon
                    </label>
                    <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 bg-white border border-accent/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all" data-id="element-94" />
                  </div>
                  <div className="space-y-2" data-id="element-95">
                    <label htmlFor="location" className="text-sm font-medium text-accent/80" data-id="element-96">
                      Objektstandort
                    </label>
                    <input type="text" id="location" name="location" className="w-full px-4 py-3 bg-white border border-accent/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all" data-id="element-97" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-98">
                  <label htmlFor="message" className="text-sm font-medium text-accent/80" data-id="element-99">
                    Nachricht
                  </label>
                  <textarea id="message" name="message" rows={4} required className="w-full px-4 py-3 bg-white border border-accent/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all resize-none" data-id="element-100"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-accent text-secondary font-medium rounded-lg hover:bg-primary transition-colors duration-300 mt-4 disabled:opacity-70" data-id="element-101">
                  {isSubmitting ? 'Wird gesendet...' : 'Erstgespräch vereinbaren'}
                </button>
                <p className="text-xs text-accent/60 mt-4 text-center leading-relaxed" data-id="element-102">
                  Mit dem Absenden des Formulars werden die von Ihnen
                  eingegebenen Daten zur Bearbeitung Ihrer Anfrage verarbeitet.
                  Weitere Informationen finden Sie in unserer{' '}
                  <a href="/?page=datenschutz" className="underline hover:text-primary transition-colors" data-id="element-103">
                    Datenschutzerklärung
                  </a>
                  .
                </p>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}